import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-landing-page-base',
    templateUrl: './landing-page-base.component.html',
    styleUrls: ['./landing-page-base.component.css'],
    standalone: true,
    imports: [MatCardModule, MatButtonModule, CommonModule]
})
export class LandingPageBase {
    @Input() headerText: string = '';
    @Input() contentText: string = '';
    constructor() {        
    }
    ngOnInit(): void {
    }
}
